import type { SvgProps } from 'react-native-svg';
import Svg, { Path } from 'react-native-svg';

export interface GoogleIconProps extends SvgProps {
  size?: number;
}

const GoogleIcon = ({ size = 15 }: GoogleIconProps) => {
  return (
    <Svg width={size} height={size} viewBox="0 0 15 15" fill="none">
      <Path
        d="M14.4007 7.36066C14.4007 6.76867 14.3517 6.33667 14.2456 5.88867H7.34766V8.56064H11.3966C11.315 9.22466 10.8742 10.2247 9.89458 10.8966L9.88085 10.9861L12.0619 12.6419L12.213 12.6567C13.6007 11.4007 14.4007 9.55265 14.4007 7.36066Z"
        fill="#5283EC"
      />
      <Path
        d="M7.34651 14.3991C9.33016 14.3991 10.9955 13.759 12.2118 12.6551L9.89344 10.895C9.27304 11.319 8.44037 11.615 7.34651 11.615C5.40366 11.615 3.75469 10.3591 3.16687 8.62305L3.08071 8.63022L0.812861 10.3502L0.783203 10.431C1.99136 12.783 4.47301 14.3991 7.34651 14.3991Z"
        fill="#58A65C"
      />
      <Path
        d="M3.16732 8.62465C3.01222 8.17666 2.92246 7.69662 2.92246 7.20065C2.92246 6.70462 3.01222 6.22464 3.15916 5.77664L3.15505 5.68123L0.858785 3.93359L0.783655 3.96861C0.285718 4.94463 0 6.04065 0 7.20065C0 8.36065 0.285718 9.45661 0.783655 10.4326L3.16732 8.62465Z"
        fill="#F1BF42"
      />
      <Path
        d="M7.34649 2.78398C8.72606 2.78398 9.65665 3.36798 10.1873 3.85602L12.2607 1.872C10.9873 0.712004 9.33013 0 7.34649 0C4.47299 0 1.99135 1.61599 0.783203 3.96797L3.1587 5.776C3.75468 4.04 5.40364 2.78398 7.34649 2.78398Z"
        fill="#D95140"
      />
    </Svg>
  );
};

GoogleIcon.displayName = 'GoogleIcon';
export { GoogleIcon };
